export const ADD_FILTER = 'ADD_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'